// (#3227) Ke kterému prostředí je aplikace připojená, podle Cognito poolu v aws-exports (ne podle adresy stránky,
// aby se to ukázalo správně i na lokálním a vzdáleném dev serveru). Označuje se jen známé testovací prostředí;
// u neznámého poolu nevíme, jestli nejde o ostrý provoz, takže zůstane bez označení.
const PRODUCTION_USER_POOL_ID = 'eu-central-1_5kc0D2tOp';

const KNOWN_NON_PRODUCTION: Record<string, { name: string; label: string }> = {
    'eu-central-1_5NVqNO34B': { name: 'testing', label: 'TEST' },
};

export type AppEnvironment =
    | { kind: 'nonProduction'; label: string; detail: string; titlePrefix: string }
    // vývojový režim (dev server) připojený k produkci
    | { kind: 'productionData'; label: string; detail: string }
    // produkční build nad produkcí nebo neznámý pool: nic se nezobrazuje
    | { kind: 'unmarked' };

export function getAppEnvironment(params: { userPoolId: string | undefined; isDev: boolean }): AppEnvironment {
    const { userPoolId, isDev } = params;

    if (userPoolId === PRODUCTION_USER_POOL_ID) {
        return isDev
            ? { kind: 'productionData', label: 'PRODUKČNÍ DATA', detail: 'vývojový server nad produkcí' }
            : { kind: 'unmarked' };
    }

    const known = userPoolId ? KNOWN_NON_PRODUCTION[userPoolId] : undefined;
    if (!known) {
        return { kind: 'unmarked' };
    }

    return { kind: 'nonProduction', label: known.label, detail: known.name, titlePrefix: `[${known.label}] ` };
}

export function prefixTitle(title: string, environment: AppEnvironment): string {
    if (environment.kind !== 'nonProduction' || title.startsWith(environment.titlePrefix)) {
        return title;
    }

    return `${environment.titlePrefix}${title}`;
}
